export default __webpack_public_path__ + "static/assets/fd76f7a29a4a9dd22a997b118018faad.png";